import "./travelList.scss";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import TravelTable from "../traveltable/TravelTable";

const TravelList = () => {
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <TravelTable />
      </div>
    </div>
  );
};

export default TravelList;
